/**
 * This helper retrieves size tokens for a particular size (small, medium, large, extra-large).
 *
 * @param size - The current size of the CloseButton.
 *
 * @returns A new object containing the button and icon size.
 */
export const getSizeTokens = size => {
  // Base tokens for common properties across variants
  const sizeTokens = {
    small: {
      padding: 'close-button-padding-small',
      iconSize: 'icon-200'
    },
    medium: {
      padding: 'close-button-padding-medium',
      iconSize: 'icon-300'
    },
    large: {
      padding: 'close-button-padding-large',
      iconSize: 'icon-400'
    },
    'extra-large': {
      padding: 'close-button-padding-extra-large',
      iconSize: 'icon-800'
    }
  };
  return sizeTokens[size];
};

/**
 * This helper retrieves variant tokens for a particular variant.
 *
 * @param variant - The current variant of the CloseButton.
 *
 * @returns A new object containing tokens for the variant's idle, hover, active, and disabled states.

 */
export const getVariantTokens = variant => {
  const tokens = {
    inverse: {
      idle: {
        backgroundColor: 'close-button-background-idle',
        color: 'close-button-icon-inverse-idle'
      },
      hover: {
        backgroundColor: 'close-button-background-hover',
        color: 'close-button-icon-inverse-idle'
      },
      active: {
        backgroundColor: 'close-button-background-pressed',
        color: 'close-button-icon-inverse-idle'
      },
      disabled: {
        backgroundColor: 'close-button-background-disabled',
        color: 'close-button-icon-inverse-disabled',
        cursor: 'not-allowed'
      }
    },
    default: {
      idle: {
        backgroundColor: 'close-button-background-idle',
        color: 'close-button-icon-default-idle'
      },
      hover: {
        backgroundColor: 'close-button-background-hover',
        color: 'close-button-icon-default-idle'
      },
      active: {
        backgroundColor: 'close-button-background-pressed',
        color: 'close-button-icon-default-idle'
      },
      disabled: {
        backgroundColor: 'close-button-background-disabled',
        color: 'close-button-icon-default-disabled',
        cursor: 'not-allowed'
      }
    }
  };
  return tokens[variant];
};